import { Modal } from 'antd';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import { COOKIE_NAME } from './constants';
import { getCookie } from './cookies';
import i18n from 'i18next';
import _ from 'lodash';

const { confirm } = Modal;

export const openConfirmModal = (
  onOk: any,
  title = 'Notification',
  description = 'Are you sure?',
  onCancel = () => {},
  okButtonText = 'Submit',
  cancelButtonText = 'Cancel',
) => {
  confirm({
    visible: true,
    title: title,
    icon: { WarningOutlined },
    content: description,
    okText: okButtonText,
    cancelText: cancelButtonText,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
    maskTransitionName: '',
    transitionName: '',
  });
};

export const countDownLogout = () => {
  let secondsToGo = 5;
  const modal = Modal.warn({
    title: i18n.t(`modal.logout.title`),
    content: i18n
      .t(`modal.logout.message`)
      .replace('TIME', secondsToGo.toString()),
    onOk: () => {
      if (timer) clearInterval(timer);
      modal.destroy();
      window.location.href = `${process.env.PUBLIC_URL}/logout`;
    },
  });
  const timer = setInterval(() => {
    secondsToGo -= 1;
    modal.update({
      content: i18n
        .t(`modal.logout.message`)
        .replace('TIME', secondsToGo.toString()),
    });
  }, 1000);
  setTimeout(() => {
    clearInterval(timer);
    modal.destroy();
    window.location.href = `${process.env.PUBLIC_URL}/logout`;
  }, secondsToGo * 1000);
};

export const countDownRefreshToken = () => {
  let secondsToGo = 5;
  const modal = Modal.warn({
    title: i18n.t(`modal.refresh_token.title`),
    content: i18n
      .t(`modal.refresh_token.message`)
      .replace('TIME', secondsToGo.toString()),
    onOk: () => {
      if (timer) clearInterval(timer);
      modal.destroy();
      window.location.reload();
    },
  });
  const timer = setInterval(() => {
    secondsToGo -= 1;
    modal.update({
      content: i18n
        .t(`modal.refresh_token.message`)
        .replace('TIME', secondsToGo.toString()),
    });
  }, 1000);
  setTimeout(() => {
    clearInterval(timer);
    modal.destroy();
    window.location.reload();
  }, secondsToGo * 1000);
};

/**
 *
 * @param object
 * @returns new object with no property undefined or null
 */
export const cleanObject = (object: any) => {
  const newObj = Object.assign({}, object);
  Object.keys(newObj).forEach(key => {
    if (newObj[key] === null || newObj[key] === undefined)
      delete newObj[key];
  });
  return newObj;
};
/**
 *
 * @param {s} input
 * @returns exp: (Nguyen Cuong => NC)
 */
export const getInitialLetterName = (s: string) => {
  let strs = s.split(' ');
  let result: any[] = [];
  strs.reverse().forEach((item: string) => {
    result.length < 2 &&
      result.push(item.substr(0, 1).toUpperCase());
  });
  return result.join('');
};

export const auth = () => {
  const tokenData = localStorage.getItem('tokenData');
  return !!getCookie(COOKIE_NAME.TOKEN) || !!tokenData;
};

/**
 * @param {number} input: number
 * @return number formatted, 100000 => 100,000
 */
export const formatNumber = (number: string) => {
  const value = number + '';
  const list = value.split('.');
  const prefix = list[0].charAt(0) === '-' ? '-' : '';
  let num = prefix ? list[0].slice(1) : list[0];
  let result = '';
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return `${prefix}${result}${
    list[1] ? `.${list[1]}` : ''
  }`;
};

/**
 *
 * @param length
 * @returns: string random has length
 */
export function generateStringRandom(length: number) {
  var result = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(
      Math.floor(Math.random() * charactersLength),
    );
  }
  return result;
}

export const addScriptDynamic = (
  src: string,
  onload:
    | ((this: GlobalEventHandlers, ev: Event) => any)
    | null,
) => {
  let script = document.createElement('script');
  script.setAttribute('src', src);
  if (onload) script.onload = onload;
  document.head.appendChild(script);
};

export const toggleItemArrs = (arrs: any[], item: any) => {
  const listXor = arrs.some((el: any) => el === item)
    ? arrs.filter((el: any) => el !== item)
    : [...arrs, item];
  return listXor;
};

/**
 *
 * @param {*} arr1: []
 * @param {*} arr2" []
 * @param {*} field: indicated whether array of object or array of item
 * @returns list item difference arr1 compared to arr2
 */
export const differenceArrays = (
  arr1: any[],
  arr2: any[],
  field = 'id',
) =>
  arr1.filter(
    (current: { [x: string]: any }) =>
      !arr2.some((el: { [x: string]: any }) =>
        field
          ? el[field] === current[field]
          : el === current,
      ),
  );

/**
 Returns the dimensions of a video asynchrounsly.
 @param {String} url Url of the video to get dimensions from.
 @return {Promise} Promise which returns the dimensions of the video in 'width' and 'height' properties.
 */
export function getVideoDimensionsOf(url: string) {
  return new Promise(resolve => {
    // create the video element
    const video = document.createElement('video');

    // place a listener on it
    video.addEventListener(
      'loadedmetadata',
      () => {
        // retrieve dimensions
        const height = video.videoHeight;
        const width = video.videoWidth;
        // send back result
        resolve({ height, width });
      },
      false,
    );

    // start download meta-datas
    video.src = url;
  });
}

export function getShortCharName(name: string) {
  if (!name) {
    return '';
  }
  name.trim();
  const arrName = name.split(' ');
  if (arrName.length === 0) return '';
  for (let index = arrName.length; index > 0; index--) {
    const element = arrName[index - 1];
    if (!element) {
      arrName.splice(index - 1, 1);
    }
  }
  if (arrName.length === 1) {
    return arrName[0][0].toUpperCase();
  }
  if (arrName.length > 1) {
    return (
      arrName[arrName.length - 2][0].toUpperCase() +
      arrName[arrName.length - 1][0].toUpperCase()
    );
  }
  return '';
}

var colors = [
  // 'linear-gradient(180deg, #6989fe 0%, #3c64f4 100%)',
  '#6989fe',
  '#08b295',
  '#f43c3c',
  '#faad14',
  '#6989fe',
  '#08b295',
  '#f43c3c',
  '#faad14',
  '#6989fe',
  '#08b295',
  '#f43c3c',
  '#faad14',
];
export function stringToColor(name: string) {
  let index = 0;
  if (!name) {
    index = 0;
  } else {
    let num = 0;
    _.each(name.split(' '), str => {
      num += str.charCodeAt(0);
    });
    while (num > 9) {
      num = getNumber(num);
    }
    index = num;
  }
  return colors[index];
}

function getNumber(num: number) {
  return num % 10;
}

export function humanFileSize(
  bytes: number,
  si = false,
  dp = 1,
) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : [
        'KiB',
        'MiB',
        'GiB',
        'TiB',
        'PiB',
        'EiB',
        'ZiB',
        'YiB',
      ];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + ' ' + units[u];
}

/**
 * Check if user is the assigner or has delegation rights for the assigner
 * @param userInfo - User info object with username and delegatorUsernames
 * @param assigner - The assigner username to check against
 * @returns true if user is the assigner or has delegation rights
 */
export const isAssignerOrDelegator = (
  userInfo:
    | { username?: string; delegatorUsernames?: string[] }
    | null
    | undefined,
  assigner: string | null | undefined,
): boolean => {
  if (!userInfo || !assigner) {
    return false;
  }
  return (
    userInfo.username === assigner ||
    (userInfo.delegatorUsernames?.includes(assigner) ??
      false)
  );
};

export const removeVietnameseAccents = (str: string) => {
  return str
    .normalize('NFD') // Tách dấu khỏi chữ cái gốc
    .replace(/[\u0300-\u036f]/g, '') // Xóa các dấu
    .toLowerCase(); // Chuyển về chữ thường
};
